import React, { createContext, useState, useContext, useEffect } from 'react';

// Local Storage Helpers
const saveToLocalStorage = (key, value) => {
  localStorage.setItem(key, JSON.stringify(value));
};

const getFromLocalStorage = (key) => {
  const item = localStorage.getItem(key);
  try {
    return item ? JSON.parse(item) : null;
  } catch (error) {
    console.error(`Failed to parse ${key} from localStorage:`, error);
    localStorage.removeItem(key); // Clear corrupted data
    return null;
  }
};

const removeFromLocalStorage = (key) => {
  localStorage.removeItem(key);
};

// Create the context
const UserContext = createContext(null);

export const UserProvider = ({ children }) => {
  const [user, setUser] = useState(null); // Initialize synchronously with null
  const [loading, setLoading] = useState(true); // NEW


  useEffect(() => {
    const storedUser = getFromLocalStorage('userData');
    if (storedUser) {
      setUser(storedUser);
    }
    setLoading(false); // done loading
  }, []);
  

  const logout = () => {
    setUser(null); // Clear user state
    removeFromLocalStorage('userData'); // Use helper function
  };

  const login = (userData) => {
    setUser(userData); // Update user state
    saveToLocalStorage('userData', userData); // Save user data to localStorage
  };

  return (
    <UserContext.Provider value={{ user, setUser, logout, login, loading }}>

      {children}
    </UserContext.Provider>
  );
};

// Hook to use the UserContext
export const useUser = () => {
  return useContext(UserContext);
};
